import { connect } from 'react-redux';
import { getThreadState } from '../../selectors';
import { pushCommentsModal } from '../../../Modals/redux/actionCreators';
import { threadUpdated } from '../../actionCreators';
const mapStateToProps = (state, { commentableItemId , commentableTypeId , parentId  })=>{
    const { streamId , canPostComment , items , maxDepth , lastInsertedCommentId  } = getThreadState(state, commentableTypeId, commentableItemId, parentId);
    return {
        streamId,
        canPostComment,
        items,
        maxDepth,
        lastInsertedCommentId
    };
};
const mapDispatchToProps = {
    onOpenCommentModal: pushCommentsModal,
    onThreadUpdated: threadUpdated
};
export default connect(mapStateToProps, mapDispatchToProps);
